import logo from '@kargotech/tms-common/Assets/Images/Logo/EnterpriseShipper/nexus-for-shipper-logo.svg';
import platform from './platform';

export default {
  ...platform,
  logo,
  projectUrl: (global.location && global.location.origin) || 'https://enterprise.kargo.tech'
};
